import {MaritalStatus} from '../../backend/enums/marital-status';
import {translations} from '../../i18n/translations';

/**
 * Array with the available genders in the Backend.
 *
 * Note: The property 'translation' gives the translation path to be used with i18n.
 * Example: t(genders[0].translation)
 * We don't return the translated value, because once set the values won't change.
 * Thus, if the user updates his language on the profile, the values given by this
 * array won't change and translate to the new language set by the user.
 */
export const maritalStatuses: Array<{translation: string; type: MaritalStatus}> = [
  {translation: translations.marital_statuses[MaritalStatus.Single], type: MaritalStatus.Single},
  {translation: translations.marital_statuses[MaritalStatus.Married], type: MaritalStatus.Married},
  {
    translation: translations.marital_statuses[MaritalStatus.CivilUnion],
    type: MaritalStatus.CivilUnion,
  },
  {translation: translations.marital_statuses[MaritalStatus.Widowed], type: MaritalStatus.Widowed},
  {
    translation: translations.marital_statuses[MaritalStatus.Divorced],
    type: MaritalStatus.Divorced,
  },
  {translation: translations.marital_statuses[MaritalStatus.Other], type: MaritalStatus.Other},
];
